import { DynamicQuestionCode } from 'types/dynamicFields'
import { getTranslation } from 'utils/translations'
import { ClientTypeValues, ConfirmValues, EntityValues } from './constants'
import { DynamicQuestionOption } from './types'

export const ConfirmOptions: DynamicQuestionOption[] = [
  { value: ConfirmValues.YES, secondaryLabel: getTranslation('yes') },
  { value: ConfirmValues.NO, secondaryLabel: getTranslation('no') },
]

export const CustomOptions: Partial<Record<DynamicQuestionCode, Record<string, string>>> = {
  qTypesOfClientsServiceIsOfferedTo: EntityValues,
  qClientTypes: ClientTypeValues,
}

export const OptionsRequiresAdditional: Partial<Record<DynamicQuestionCode, string[]>> = {
  qTypesOfClientsServiceIsOfferedTo: [EntityValues.CORPORATES, EntityValues.BOTH],
  qClientTypes: [ClientTypeValues.PROFESSIONAL, ClientTypeValues.BOTH],
}
